import FirmaDocumento from "global/component/Genericos/FirmaDocumento/FirmaDocumento";
import {
  BodyAutorizacionOrden,
  ContainerFirmaOrden,
  TopAutorizacionOrden,
} from "./localStyle";
import { useState } from "react";

const FirmaOrden = ({ idTurno, finalizarProceso, dissmiss, isMobile }) => {
  const [img, setImg] = useState("");

  const handleClick = (e) => {
    const obj = {
      binario: img,
      idRemoto: idTurno,
      tag: "png",
      autocheck: true,
    };
    finalizarProceso([obj], true, true);
  };
  const onChange = (e) => {
    setImg(e);
  };

  return (
    <ContainerFirmaOrden>
      <TopAutorizacionOrden>
        <h1>Firma de orden</h1>
        <span className="cruz" onClick={dissmiss}>
          X
        </span>
      </TopAutorizacionOrden>
      <BodyAutorizacionOrden>
        <h1>
          {isMobile
            ? "Ahora ingrese su firma con el dedo en el rectangulo de abajo y luego toque firmar"
            : "Ahora ingrese su firma con el cursor del mouse en el rectángulo de abajo y luego haga click en firmar."}
        </h1>
        <FirmaDocumento onClick={handleClick} onChange={onChange} />
      </BodyAutorizacionOrden>
    </ContainerFirmaOrden>
  );
};

export default FirmaOrden;
